export const SPECIAL_MENU_GET_REQUEST = 'SPECIAL_MENU_GET_REQUEST';
export const SPECIAL_MENU_GET_SUCCESS = 'SPECIAL_MENU_GET_SUCCESS';
export const SPECIAL_MENU_GET_FAILURE = 'SPECIAL_MENU_GET_FAILURE';

export const SPECIAL_MENU_GET_BY_ID_REQUEST = 'SPECIAL_MENU_GET_BY_ID_REQUEST';
export const SPECIAL_MENU_GET_BY_ID_SUCCESS = 'SPECIAL_MENU_GET_BY_ID_SUCCESS';
export const SPECIAL_MENU_GET_BY_ID_FAILURE = 'SPECIAL_MENU_GET_BY_ID_FAILURE';

export const SPECIAL_MENU_CREATE_OR_UPDATE_REQUEST = 'SPECIAL_MENU_CREATE_OR_UPDATE_REQUEST';
export const SPECIAL_MENU_CREATE_OR_UPDATE_SUCCESS = 'SPECIAL_MENU_CREATE_OR_UPDATE_SUCCESS';
export const SPECIAL_MENU_CREATE_OR_UPDATE_FAILURE = 'SPECIAL_MENU_CREATE_OR_UPDATE_FAILURE';

export const SPECIAL_MENU_DELETE_REQUEST = 'SPECIAL_MENU_DELETE_REQUEST';
export const SPECIAL_MENU_DELETE_SUCCESS = 'SPECIAL_MENU_DELETE_SUCCESS';
export const SPECIAL_MENU_DELETE_FAILURE = 'SPECIAL_MENU_DELETE_FAILURE';

export const RESET_SPECIAL_MENU_ERRORS = 'RESET_DISHES_ERRORS';

export const CHANGE_SPECIAL_MENU_FORM_STEP = 'CHANGE_SPECIAL_MENU_FORM_STEP';

export const RESET_SPECIAL_MENU_LIST_DATA = 'RESET_SPECIAL_MENU_LIST_DATA';

export const SPECIAL_MENU_CHANGE_POSITION_REQUEST = 'SPECIAL_MENU_CHANGE_POSITION_REQUEST';
export const SPECIAL_MENU_CHANGE_POSITION_SUCCESS = 'SPECIAL_MENU_CHANGE_POSITION_SUCCESS';